module.exports = __webpack_public_path__ + "img/printing-tips.3b022241.svg";